import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { useAnalytics } from 'use-analytics';
import clsx from 'clsx';
import { getTravelAgency } from '../../../../store/slices/user';
import Dropdown from '../../../Dropdown';

const NavbarHelpDropdown = ({ doShowWithBranding }) => {
  const { track } = useAnalytics();
  const travelAgency = useSelector(getTravelAgency);
  const doHideHelpInNavbar = travelAgency && travelAgency.siteTheme
    && travelAgency.siteTheme.doHideHelpInNavbar;

  const handleClickHelp = () => {
    track('navbarHelpMenuClick');
  };

  return !doHideHelpInNavbar && travelAgency && travelAgency.helpMenuHtml ? (
    <Dropdown className={clsx('cursor-pointer self-center')}>
      <Dropdown.Toggle>
        <a className="inline-block align-middle text-sm md:text-lg self-center" tabIndex="-1" role="button" onClick={handleClickHelp} onKeyDown={() => {}}>
          <span>{(travelAgency?.siteTheme || {}).navbarHelpMenuLabel || 'HELP'}</span>
        </a>
      </Dropdown.Toggle>
      <Dropdown.Menu widthClass="w-56 md:w-96" shadowClass="shadow-2xl" alignClass={clsx({ 'left-0 md:left-auto right-auto md:right-0': doShowWithBranding })}>
        <Dropdown.Item withGridLayout={false}>
          <div dangerouslySetInnerHTML={{ __html: travelAgency.helpMenuHtml }} className="whitespace-normal break-all md:break-normal" />
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  ) : <></>;
};

NavbarHelpDropdown.propTypes = {
  doShowWithBranding: PropTypes.bool,
};

NavbarHelpDropdown.defaultProps = {
  doShowWithBranding: false,
};

export default memo(NavbarHelpDropdown);
